export function extractSchemePath(url = "") {
  const matches = url.match(/^penfold:\/\/(.*)$/);

  if (matches) {
    const [, path] = matches;
    return path.startsWith("/") ? path : `/${path}`;
  }
}

export function extractBranchPreviewHost(url = "") {
  const matches = url.match(
    /^penfold:launch\?host=(penfold-web-[a-zA-Z0-9-]+-penfold-dev\.vercel\.app)$/
  );

  if (matches) {
    const [, host] = matches;
    return host;
  }
}
